<div [class]="hostClass" [ngClass]="{ 'rounded-md bg-card shadow-md': true }">
    <div *ngIf="title" class="flex items-center justify-between gap-1 px-4 py-2 font-normal shadow-md">
        <h5 class="text-lg">{{ title | translate }}</h5>
        <div *ngIf="nrOfActiveFilters > 0" class="text-sm">Active filters: {{ nrOfActiveFilters }}</div>
    </div>
    <div [class]="contentClass" [ngClass]="{ 'p-4': true }">
        <ng-content></ng-content>
    </div>
</div>
